function fn_part_gallery_slider() {
    var gallery_slider = $(".part-gallery-slider");
    var gallery_slider_inner = gallery_slider.find(".inner");
    var gallery_slider_thumbs = gallery_slider.find(".thumbs");
    if (gallery_slider_inner.length) {
        gallery_slider_inner.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            fade: true,
            cssEase: 'linear',
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            asNavFor: gallery_slider_thumbs
        });
        gallery_slider_inner.on('beforeChange', function(slick){
            $(this).find(".slick-active").next().find("img").addClass("lazyload");
        });

        gallery_slider_thumbs.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: gallery_slider_inner,
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: false,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
        gallery_slider_thumbs.on('beforeChange', function(slick){
            gallery_slider_inner.find(".slick-active").find("img").addClass("lazyload");
        });

        gallery_slider_inner.lightGallery({
            thumbnail: true,
            selector: '.item',
            exThumbImage: 'data-exthumbimage'
        });
    }
}